<template>
	<div>
		<div v-for="(action, index) in actions" :key="index">
			<span class="icon-wrapper" v-if="!isEmptyObject(action)">
				<i :class="{ active : action.opened}">
					<OpenedIcon></OpenedIcon>
				</i>
				<i :class="{ active : action.accepted}">
					<GotItIcon></GotItIcon>
				</i>
				<i :class="{ active: action.action}">
					<LearnMoreIcon></LearnMoreIcon>
				</i>
			</span>
			<span class="no-action" v-else>
				<NoActionIcon></NoActionIcon>
				<span> No Action</span>
			</span>
		</div>
	</div>
</template>

<script>
import CommonMixin from './mixin'
// import Icons from '../icon/components'

export default {
	name: 'action-icons',
	mixins: [CommonMixin],
	props: {
		actions: {
			type: Array
		}
	},
	components: {
		// ...Icons
	}
}
</script>

<style scoped>
.icon-wrapper{
	display: flex;
	align-items: center;
	padding: 5px 0px;
}
.icon-wrapper>i{
	padding: 0px 7px;
	line-height: 10px
}
.icon-wrapper>i>svg{
	stroke: #cccccc;
}
.icon-wrapper>i.active>svg{
	stroke: #44b358;
}
.no-action{
	display: flex;
	align-items: center;
	font-size: 14px;
	padding: 5px 0;
}
.no-action>span{
	padding-left: 5px;
	color: #da4e4e;
}
.no-action>svg{
	height: 22px;
}
</style>
